import {Injectable} from "@angular/core";
import {OutpostRepository} from "../../../domain/outposts/outpost-repository";
import {HttpService} from "../../http/http";
import {Outpost} from "../../../domain/outposts/outpost";
import {OutpostStatus} from "../../../domain/outposts/OutpostStatus";


@Injectable()
export class OutpostRepositoryImpl implements OutpostRepository {
  private static readonly API_BASE = "outpostmanagement";

  constructor(
    private httpService: HttpService,
  ) {}

  getOutposts(tenantId?: number): Promise<Outpost[]> {
    let url = `${OutpostRepositoryImpl.API_BASE}/outposts`;
    if (tenantId) {
      url += `?tenantIdParam=${tenantId}`;
    }

    return this.httpService.get(url).then((result: any[]) => {
      if (!result || !Array.isArray(result)) {
        return [];
      }
      return result.map(
        (item) => new Outpost(item.outpost_id, item.outpost_name)
      );
    });
  }

  getStatuses(tenantId?: number): Promise<OutpostStatus[]> {
    let url = `${OutpostRepositoryImpl.API_BASE}/statuses`;
    if (tenantId) {
      url += `?tenantIdParam=${tenantId}`;
    }

    return this.httpService.get(url).then((result: any[]) => {
      if (!result || !Array.isArray(result)) {
        return [];
      }
      return result.map(
        (item) => new OutpostStatus(
          item.outpost_id,
          item.is_online,
          new Date(item.last_seen_utc)
        )
      );
    });
  }

  startSession(outpostId: string): Promise<{ iframeUrl: string }> {
    const url = `${OutpostRepositoryImpl.API_BASE}/${outpostId}/start-session`;
    return this.httpService.post(url, null);
  }
}
